import { toast } from "@/components/ui";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

interface CreateVideoVisitMeetingParams {
  encounterId: string;
}

interface CreateVideoVisitMeetingResponse {
  data: {
    token: string;
    url: string;
    roomName: string;
  };
}

export const useCreateVideoVisitMeeting = () => {
  return useApiMutation<
    CreateVideoVisitMeetingResponse,
    CreateVideoVisitMeetingParams
  >({
    mutationOptions: {
      mutationKey: ["video-visit-meeting", "create"],
      mutationFn: ({ encounterId }) => {
        return axiosInstance.post("new-api/video-visit/rooms/provision", {
          encounterId,
        });
      },
      onError: () => {
        toast.error("Failed to create video visit meeting");
      },
    },
  });
};
